import React from "react";
import aboutHeroImage from '../../img/about-us-banner.jpg'; // Replace with the correct image path
import Footer from "../home-page/Footer";


import "./Blog.css"; // Make sure to create the CSS file for styling
import { FaMountain, FaUniversity, FaHiking } from "react-icons/fa"; // Importing icons
import dest1 from "../../img/bhuleshwar.avif";
import dest2 from "../../img/MIT.jpg";
import dest3 from "../../img/nane-ghat.jpg";
import dest4 from "../../img/shaniwar-wada.jpg";
import dest5 from "../../img/aurangabad.jpg";

const Blog = () => {
  const blogs = [
    {
      category: "Nature • Maharashtra",
      title: "Blissful Bhuleshwar",
      description:
        "Bhuleshwar, a hidden gem in Maharashtra, offers stunning vistas, rich flora, and historical significance. It's a perfect retreat for nature lovers and history enthusiasts alike.",
      icon: <FaMountain />, // Icon for nature
      image: dest1,
    },
    {
      category: "Cultural Walk • Heritage",
      title: "Heritage Orientation Walk for MIT WPU B.Des",
      description:
        "Experience the cultural legacy of Pune through an educational walk designed for students. Learn about the architecture and history that shaped the city's heritage.",
      icon: <FaUniversity />, // Icon for heritage
      image: dest2,
    },
    {
      category: "Adventure • Trekking",
      title: "Nane Ghat",
      description:
        "Step back in time with a trek to Nane Ghat, an ancient mountain pass used by traders. Surrounded by lush greenery and offering stunning views, it's a trekker's delight.",
      icon: <FaHiking />, // Icon for adventure
      image: dest3,
    },
    {
      category: "Cultural Walk • History",
      title: "Old Pune Heritage Walk for B.Des, Pune Design School, PCU",
      description:
        "Explore Pune's rich history through an interactive heritage walk designed for students. Discover the stories behind the city's iconic landmarks.",
      icon: <FaUniversity />, // Reused icon for cultural walks
      image: dest4,
    },
    {
      category: "Heritage • Exploration",
      title: "Aurangabad Heritage Tour for Delegates of The Iran Culture House of Mumbai",
      description:
        "An exclusive tour showcasing Aurangabad's cultural and historical gems, including the Ajanta and Ellora Caves. A journey through time and tradition.",
      icon: <FaMountain />, // Reused icon for exploration
      image: dest5,
    },
  ];

  return (
    <div className="blog-page">
      <div className="about-hero-section">
        <img src={aboutHeroImage} alt="About Us" className="about-hero-image" />
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1>Explore</h1>
          <div className="breadcrumb">
            <span>Explore</span> &gt; <span>Blogs</span>
          </div>
        </div>
      </div>
      <h1 className="blog-header">Celebrating <span className="highlight-blog">Heritage!</span> </h1>
      <div className="blog-container">
        {blogs.map((blog, index) => (
          <div className="blog-item" key={index}>
            <img src={blog.image} alt={blog.title} className="blog-image" />
            <div className="blog-text">
              {/* <div className="blog-icon">{blog.icon}</div> */}
              <p className="blog-category">{blog.category}</p>
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              {/* <button className="read-more-btn">Read More</button> */}
            </div>
          </div>
        ))}
      </div>
      <Footer/>
    </div>
  );
};

export default Blog;
